import { render, staticRenderFns } from "./GestionarPropuestas.vue?vue&type=template&id=563165d8&scoped=true"
import script from "./GestionarPropuestas.vue?vue&type=script&lang=js"
export * from "./GestionarPropuestas.vue?vue&type=script&lang=js"
import style0 from "./GestionarPropuestas.vue?vue&type=style&index=0&id=563165d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563165d8",
  null
  
)

export default component.exports